// extracted by mini-css-extract-plugin
export var currencyInput = "_k6-1";
export var currencySymbol = "_k6-0";